import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propBool, propFunc, propShape, propStr, } from '../../../helpers/custom-prop-types';
import SlideSearchRegistrationModals from '../Common/Modal/SlideSearchRegistrationModals';
import SlideSearchUploadProgressModal from '../Common/Modal/SlideSearchUploadProgressModal';
import SlideSearchCompletedModal from '../Common/Modal/UploadProgressModal/Completed/SlideSearchCompletedModal';
import SlideSearchTopTutorialModals from './SlideSearchTopTutorialModals';
const SlideSearchTopModals = (props) => {
    const { canRegistrationTrial, email, finishOnBoarding, hideCompleteModal, hideFormModal, hidePaidModal, hideUploadCompleteModal, hideUploadProgressModal, initialValues, isFree, isRequiredProfileUpdate, isShowCompleteModal, isShowFormModal, isShowPaidModal, isShowSearchFirstView, kanaRef, modalInformation, onSubmitOnlyNameAndPositionRegistration, onSubmitRegistration, userMode, } = props;
    const showModalMode = useMemo(() => {
        if (isShowSearchFirstView || isRequiredProfileUpdate) {
            return 'SlideSearchTopTutorialModals';
        }
        if (modalInformation.showProgressModal) {
            return 'SlideSearchUploadProgressModal';
        }
        if (modalInformation.showCompleteModal) {
            return 'SlideSearchCompletedModal';
        }
        if (isShowCompleteModal || isShowFormModal || isShowPaidModal) {
            return 'SlideSearchRegistrationModals';
        }
        return '';
    }, [
        isRequiredProfileUpdate,
        isShowCompleteModal,
        isShowFormModal,
        isShowPaidModal,
        isShowSearchFirstView,
        modalInformation.showCompleteModal,
        modalInformation.showProgressModal,
    ]);
    return (_jsxs(_Fragment, { children: [_jsx(SlideSearchTopTutorialModals, { finishOnBoarding: finishOnBoarding, isFree: isFree, isRequiredProfileUpdate: isRequiredProfileUpdate, isShow: showModalMode === 'SlideSearchTopTutorialModals', isShowSearchFirstView: isShowSearchFirstView, kanaRef: kanaRef, onSubmitOnlyNameAndPositionRegistration: onSubmitOnlyNameAndPositionRegistration, userMode: userMode }), _jsx(SlideSearchUploadProgressModal, { hideModal: hideUploadProgressModal, isShow: showModalMode === 'SlideSearchUploadProgressModal', modalInformation: modalInformation }), _jsx(SlideSearchCompletedModal, { hideModal: hideUploadCompleteModal, isShow: showModalMode === 'SlideSearchCompletedModal', modalInformation: modalInformation }), _jsx(SlideSearchRegistrationModals, { canRegistrationTrial: canRegistrationTrial, email: email, hideCompleteModal: hideCompleteModal, hideFormModal: hideFormModal, hidePaidModal: hidePaidModal, initialValues: initialValues, isShowCompleteModal: showModalMode === 'SlideSearchRegistrationModals' &&
                    isShowCompleteModal, isShowFormModal: showModalMode === 'SlideSearchRegistrationModals' && isShowFormModal, isShowPaidModal: showModalMode === 'SlideSearchRegistrationModals' && isShowPaidModal, kanaRef: kanaRef, onSubmitRegistration: onSubmitRegistration, userMode: userMode })] }));
};
SlideSearchTopModals.propTypes = {
    canRegistrationTrial: propBool().isRequired,
    email: propStr().isRequired,
    finishOnBoarding: propFunc().isRequired,
    hideCompleteModal: propFunc().isRequired,
    hideFormModal: propFunc().isRequired,
    hidePaidModal: propFunc().isRequired,
    hideUploadCompleteModal: propFunc().isRequired,
    hideUploadProgressModal: propFunc().isRequired,
    initialValues: propShape().isRequired,
    isFree: propBool().isRequired,
    isRequiredProfileUpdate: propBool().isRequired,
    isShowCompleteModal: propBool().isRequired,
    isShowFormModal: propBool().isRequired,
    isShowPaidModal: propBool().isRequired,
    isShowSearchFirstView: propBool().isRequired,
    kanaRef: propShape().isRequired,
    modalInformation: propShape().isRequired,
    onSubmitOnlyNameAndPositionRegistration: propFunc().isRequired,
    onSubmitRegistration: propFunc().isRequired,
    userMode: propStr().isRequired,
};
export default SlideSearchTopModals;
